/**
 * 「从城郊到城市」这一章新增的物品。
 *
 * 单独一个文件，不去改 items.js：installExpansionItems() 会把它们注册进 ITEMS，
 * getItem() 立刻就能查到。拾荒能翻出什么在各家的货单里（systems/loot.js），
 * 这里只负责「这东西叫什么、值不值钱、能不能叠」。
 */
export const EXPANSION_ITEMS = {
  /* ---- 拾荒废品：满地都是，攒起来才值钱 ---- */
  plasticBottle: { name: '塑料瓶', desc: '城里人喝完就扔的东西。', stack: 99 },
  tornCardboard: { name: '纸板', desc: '压平了能卖几文。', stack: 99 },
  usedClothing: { name: '破布', desc: '洗洗还能擦东西。', stack: 99 },
  brokenGlass: { name: '碎玻璃', desc: '小心扎手。', stack: 99 },
  tinCan: { name: '易拉罐', desc: '铁皮薄薄一层。', stack: 99 },
  wornOutShoes: { name: '破鞋', desc: '底都磨穿了。', stack: 99 },
  foam: { name: '泡沫', desc: '轻，风一吹就跑。', stack: 99 },
  wovenScraps: { name: '编织袋碎片', desc: '撕成条能当绳。', stack: 99 },
  steelWireScrap: { name: '铁丝头', desc: '弯弯扭扭一小截。', stack: 99 },
  constructionDebris: { name: '大件建筑垃圾', desc: '两个人未必抬得动。', stack: 20 },
  ironRimPiece: { name: '铁箍碎片', desc: '木桶上崩下来的。', stack: 99 },
  burlapSack: { name: '粗麻布袋', desc: '结实，能装不少东西。', stack: 20 },
  wovenBag: { name: '完整编织袋', desc: '装货、垫床都行。', stack: 20 },
  strawSandals: { name: '草鞋', desc: '走土路比布鞋耐磨。', stack: 5 },

  /* ---- 废车零件 ---- */
  usedTire: { name: '旧轮胎', desc: '花纹还剩一点。', stack: 20 },
  usedValve: { name: '旧气门嘴', desc: '还能凑合用。', stack: 99 },
  usedDiff: { name: '旧差速器', desc: '沉甸甸一坨铁。', stack: 5 },
  usedOilPump: { name: '旧油泵', desc: '油泥糊得看不出本色。', stack: 5 },
  wasteEngineOil: { name: '废机油', desc: '黑得发亮。', stack: 20 },
  oldSteeringWheel: { name: '旧方向盘', desc: '握着倒还顺手。', stack: 5 },

  /* ---- 鱼虾 ---- */
  commonFish: { name: '杂鱼', desc: '小，炸着吃还行。', stack: 20 },
  carp: { name: '鲤鱼', desc: '城里人爱讨个彩头。', stack: 20 },
  catfish: { name: '鲶鱼', desc: '肉厚刺少。', stack: 20 },
  crucianCarp: { name: '鲫鱼', desc: '炖汤最鲜。', stack: 20 },
  liveCatfish: { name: '活鲶鱼', desc: '还在动，能卖上价。', stack: 10 },
  perch: { name: '鲈鱼', desc: '贵，酒楼才收。', stack: 10 },

  /* ---- 园子里的配料 ---- */
  onionBulb: { name: '洋葱头', desc: '切的时候别哭。', stack: 30 },
  pepperSeedling: { name: '辣椒苗', desc: '种下去能结一串。', stack: 20 },
  tomatoSeedling: { name: '番茄苗', desc: '得给它搭架子。', stack: 20 },

  /* ---- 证据与门路 ---- */
  villainsEvidence: { name: '恶霸勒索的字据', desc: '名字底下按着手印。', stack: 5 },
  falsifiedLedger: { name: '伪造的账本', desc: '墨迹还没干透。', stack: 5 },

  /* ---- 见不得光的货 ---- */
  smuggledSalt: { name: '私盐包', desc: '没引的盐，见不得光。', stack: 10 },
  unstampedLiquor: { name: '未完税的酒', desc: '封条是假的。', stack: 10 },

  /* ---- 身份凭证：拿到手才算数 ---- */
  contractorsLicenseApprentice: { name: '作场准许（帮工学徒）', desc: '凭这个能进人家的作场。', stack: 1 },
  nighthawkBasic: { name: '夜行木牌（基础）', desc: '起更后也能在街上走。', stack: 1 },
  deedApprentice: { name: '地契（学徒田产）', desc: '一小块地，写着你的名字。', stack: 1 },
  cityResidencePermitApprentice: { name: '临时居留（学徒）', desc: '能在城里住上半年。', stack: 1 },
  studentsScholarship: { name: '学子膏火', desc: '每月能领一点补贴。', stack: 1 },
  merchantTransportLicense: { name: '行商牌', desc: '货物进出城门凭它。', stack: 1 },

  /* ---- 活物的产出 ---- */
  egg: { name: '鸡蛋', desc: '母鸡下的，还热乎。', stack: 30 },
  wool: { name: '羊毛', desc: '剪下来带着膻味。', stack: 20 },

  /* ---- 谋生的零碎 ---- */
  notePaper: { name: '素纸信封', desc: '写字用，也能糊窗户。', stack: 30 },
  fireFan: { name: '火钳煽', desc: '引火的小家什。', stack: 5 },
  petCage: { name: '兽笼', desc: '关活物用的。', stack: 5 },
  baitWorms: { name: '红虫饵', desc: '钓大物要靠它。', stack: 30 },
  insects: { name: '蛴螬幼虫', desc: '鸡最爱这个。', stack: 30 },
  soapNut: { name: '皂角', desc: '搓出沫子能去味。', stack: 20 },

  /* ---- 铺子里常备的日用品 ---- */
  salt: { name: '粗盐', desc: '腌什么都靠它。', stack: 30 },
  seasoning: { name: '调料', desc: '一小包，够炒几个菜。', stack: 20 },
  oil: { name: '灯油', desc: '添进灯里能亮半夜。', stack: 20 },
  firewood: { name: '柴', desc: '灶膛里最重要的东西。', stack: 30 },
  medicine: { name: '成药', desc: '苦，但管用。', stack: 10 },
  liquor: { name: '浊酒', desc: '喝多了第二天头疼。', stack: 10 },
  lamp: { name: '油灯', desc: '夜里唯一的亮。', stack: 5 },
  animalFeed: { name: '粗饲料', desc: '糠、麸、碎豆子拌的。', stack: 40 },
  chicken: { name: '鸡', desc: '会下蛋，也会吵。', stack: 5 },
  chickenManure: { name: '鸡粪', desc: '臭，但庄稼爱它。', stack: 40 },
  book: { name: '旧书', desc: '字还清楚，纸脆了。', stack: 5 },
};
